import React from 'react';
import UseYoutubePreview from "./YoutubePreview.hooks";
import { makeYoutubeTemplate } from '../embedUtilities';

const YouTubePreview =({url, setDisableUpload, setIsLoading, isLoading, setEmbedId}:{url: string, setDisableUpload: any, setIsLoading: any, isLoading: boolean, setEmbedId:any}) => {

    const {id} = UseYoutubePreview(url, isLoading, setIsLoading, setDisableUpload);

    if (isLoading) {
        return <div className="spacer" />
    }

    if (!id) {
        return <span className="error-message">We couldn't find a source for that Youtube embed. Please try again.</span>
    
    } else {
        setEmbedId(id);
        
        return ( 
            <div className='embed-preview-container youtube-preview'>
                <div className="preview-tab">Preview</div>

                <div dangerouslySetInnerHTML={{__html:makeYoutubeTemplate(id)}}/>
            </div>
        )
    }
}

export default YouTubePreview
